// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".onlyShowTotal--2oi1Bk_j li:not(.ant-pagination-total-text) {\n      display: none;\n    }\n\n.totalText--1VtjJ8Jx {\n  color: var(--antd-pagination-total-text);\n}\n\n.totalText--1VtjJ8Jx .total--1dhB9qLi {\n    font-weight: normal;\n    color: var(--antd-pagination-total-strong-text);\n  }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"onlyShowTotal": "onlyShowTotal--2oi1Bk_j",
	"totalText": "totalText--1VtjJ8Jx",
	"total": "total--1dhB9qLi"
};
export default ___CSS_LOADER_EXPORT___;
